import request from '@/utils/request'

export function updateBuildCfgList(data) {
  return request({
    url: 'api/v1/build/updateBuildCfg',
    method: 'post',
    data: data
  })
}

export function getBuildCfgList(data) {
  return request({
    url: 'api/v1/build/getBuildCfg',
    method: 'post',
    data: data
  })
}

export function exportBuildCfg(data) {
  return request({
    url: 'api/v1/build/export',
    method: 'post',
    data: data
  })
}

export function importBuildCfg(data) {
  return request({
    url: 'api/v1/build/import',
    method: 'post',
    data: data
  })
}

